const SkeletonRow = ({ colCount }) => (
  <tr>
    {Array.from({ length: colCount }).map((_, i) => (
      <td key={i} className="px-4 py-3">
        <div className="h-4 bg-gray-100 rounded animate-pulse" />
      </td>
    ))}
  </tr>
);

const DataTable = ({ columns, children, isLoading }) => (
  <div className="overflow-x-auto mt-4">
    <table className="w-full border-collapse">
      <thead>
        <tr className="bg-primary-500">
          {columns.map((col, i) => (
            <th
              key={i}
              className={`text-white text-sm font-medium px-4 py-3 text-left
                ${i === 0 ? "rounded-tl-md" : ""}
                ${i === columns.length - 1 ? "rounded-tr-md" : ""}`}
            >
              {col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-[#f0f0f0]">
        {isLoading
          ? Array.from({ length: 5 }).map((_, i) => (
              <SkeletonRow key={i} colCount={columns.length} />
            ))
          : children}
      </tbody>
    </table>
  </div>
);

export default DataTable;
